import { GET_PURCHASE_DETAILS_ERROR, GET_PURCHASE_DETAILS_LOADING, GET_PURCHASE_DETAILS_SUCCESS } from './types';

export const getPurchaseDetailsLoading = () => ({
  type: GET_PURCHASE_DETAILS_LOADING
});
export const getPurchaseDetailsSuccess = data => ({
  type: GET_PURCHASE_DETAILS_SUCCESS,
  purchaseDetails: data
});
export const getPurchaseDetailsError = error => ({
  type: GET_PURCHASE_DETAILS_ERROR,
  error
});
